var exports = {
  "y": "gap_2__w9p9x1",
};

module.exports = exports;
